<template>
  <div>
    <div class="carousel">
      <div :class="['image-wrapper', transitionName]" :style="{ transform: `translateX(${-currentIndex * 100}%)` }">
        <img v-for="(item, index) in imageTexts" :key="index" :src="item.image" alt="Carousel Image" class="image" />
      </div>
      <p class="textColor">{{ currentText }}</p>
    </div>
    <div class="button-container">
      <button @click="prevImage" class="prev-button" :disabled="isFirstImage">&#60;</button>
      <button @click="nextImage" class="next-button" :disabled="isLastImage">&#62;</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imageTexts: [
        {
          image: ('https://download.hecoos.com/enlightv/2025-17/2047ae4d53f30580adec9c4a7719b9ad.png'),
          text: '三维场景预演、投影仿真、灯光效果编辑与导播设计'
        },
        {
          image: 'https://download.hecoos.com/enlightv/2025-17/a25b47a39e2b1bebeab4e93ea3fa85ae.png',
          text: '2*2K测试信号输出(带水印) 外部设备控制(间歇性中断)'
        }
        ,
        {
          image: 'https://download.hecoos.com/enlightv/2025-17/9c609c133d5ff2e733e08934ef8167c5.png',
          text: '节目与控制指令编辑 项目现场调试'
        },
        {
           image: 'https://download.hecoos.com/enlightv/2025-17/2047ae4d53f30580adec9c4a7719b9ad.png',
          text: 'Windows PC'
        }
      ],
      currentIndex: 0,
      transitionName: 'fade-slide' // 初始动画类名
    };
  },
  computed: {
    currentText() {
      return this.imageTexts[this.currentIndex].text;
    },
    isFirstImage() {
      return this.currentIndex === 0;
    },
    isLastImage() {
      return this.currentIndex === this.imageTexts.length - 1;
    }
  },
  methods: {
    prevImage() {
      this.transitionName = 'fade-slide-prev';
      this.currentIndex = (this.currentIndex - 1 + this.imageTexts.length) % this.imageTexts.length;
    },
    nextImage() {
      this.transitionName = 'fade-slide-next';
      this.currentIndex = (this.currentIndex + 1) % this.imageTexts.length;
    }
  }
};
</script>

<style scoped>
.carousel {
  width: 100%;
  overflow: hidden; 
}
.image-wrapper {
  display: flex;
  transition: transform 1s ease;
  
}
.image {
  width: 100%;
  height: auto;
  top: 0;
  left: 0;
  opacity: 0;
  animation: fadeIn 0.7s ease forwards;
  
  
}
.textColor{
  padding: 10px 0 0 0;
  color: rgba(133, 133, 138, 1);
}
.button-container {
  display: flex;
  justify-content: right;
  gap: 10px; 
  padding-top: 20px;
}
.prev-button,
.next-button {
  padding: 8px 12px;
  background-color: #1B1818; 
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  transition: background-color 0.3s ease;
}
.prev-button:hover,
.next-button:hover {
  background-color: #343334; 
}
.fade-slide-next image {
  animation: fadeIn 0.7s ease forwards;
}
.fade-slide-prev image {
  animation: fadeIn 0.7s ease forwards;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>